<template>
    <div class="btn-wrapper d-flex">
        <div
            v-for="option in this.options"
            :key="option.id"
            class="choice-btn d-flex"
            :class="{
                active: isSelected(option.id),
                true: getBinaryValue(option.id),
                false: !getBinaryValue(option.id),
                colored: coloredTheme,
            }"
            @click="updateInputValue(option.id)"
        >
            <i
                v-if="showIcon"
                class="icon-cr"
                :class="{
                    'icon-btn-true': getBinaryValue(option.id),
                    'icon-btn-false': !getBinaryValue(option.id),
                }"
            />
            <span class="btn-text text-uppercase"> {{ option.text }} </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BinaryChoiceComponent',
        props: {
            showIcon: {
                type: Boolean,
                default: true,
            },
            coloredTheme: {
                type: Boolean,
                default: false,
            },
            options: {
                type: Array,
                default: () => [
                    { id: 1, text: 'Sim' },
                    { id: 0, text: 'Não' },
                ],
            },
        },
        data() {
            return {
                selectedChoice: null,
            };
        },
        methods: {
            updateInputValue(value) {
                this.selectedChoice = value;
                this.$emit('update-selection', this.selectedChoice);
            },
            getBinaryValue(id) {
                return this.options[0].id === id ? true : false;
            },
            isSelected(id) {
                return this.selectedChoice === id;
            },
        },
    };
</script>
